const filterClass = '.hpe-product-list__sidebar';
const activeClass = 'hpe-product-list__sidebar--open';

$('.hpe-product-list__filter-button').click(function () {
  $(filterClass).toggleClass(activeClass);
  $('body').addClass('hpe-body-noscroll');
});

$('.hpe-product-list__close-button').click(function () {
  $(filterClass).removeClass(activeClass);
  $('body').removeClass('hpe-body-noscroll');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/toggle-filters.js